import DragIconTableData from "../../components/common/DragIconTableData.jsx";
import Tooltip from "../../components/common/Tooltip.jsx";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useContext, useEffect, useState } from "react";
import { db, timestamp } from "../../firebase/config.js"
import { v4 as uuid } from 'uuid';
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { useFirestore } from "../../firebase/useFirestore.js";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Modal from '../common/Modal';
import ActivityFieldTypeConfig from "../../components/common/ActivityFieldTypeConfig.jsx";
import { client } from "../../hooks/Client"
import Table from "../common/table/Table.jsx";
import TableCell from "../common/table/TableCell.jsx";
import TableDragHandleCell from "../common/table/TableDragHandleCell.jsx";

const Activities = ({selectedOption}) => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)

    // State
    const [dragArray, setDragArray] = useState([]);
      const [modalOpen, setModalOpen] = useState(false)
      const [selectedField, setSelectedField] = useState('')
       const [selectedFieldIndex, setSelectedFieldIndex] = useState('')
    const [editField, setEditField] = useState('')

    // Firestore
     const customEventFields = useFirestore("CustomEventFields")

      // Hooks


    // Whenever Firestore data changes, update dragArray state
    useEffect(() => {
        setDragArray(customEventFields);
    }, [customEventFields]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
        if (!result.destination) return;
    
        const items = Array.from(dragArray);
        const [movedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, movedItem);
    
        // Update local state to reflect the reorder immediately
        setDragArray(items);
    
        // Now update Firestore with new positions
        items.forEach((item, idx) => {
            db.collection('CustomEventFields')
            .doc(item.docid) // assuming .docid is stored for each doc
            .update({ Position: idx + 1 });
        });
    
        // Show "saved" icon
        setSaved('flex');
        };

    
    // Add custom event field
    const addCustomEventField = () => {
        db.collection('CustomEventFields')
        .add({
                ID: uuid(),
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            Title: 'Nieuw aangepast veld',
            Position: customEventFields.length + 1,
            Type: 'open',
            PortfolioShared: 'true',
        });
    };

    // Delete custom field handler
    const deleteCustomFieldHandler = (e) => {
        const docid = e.currentTarget.dataset.docid;

        db.collection("CustomEventFields")
        .doc(docid)
        .delete()
        .then(() => {
            console.log("Custom field deleted");
        })
        .catch((error) => {
            console.error("Error deleting custom field:", error);
        });
    };

    // Custom event title change handler
    const customEventFieldTitleHandler = (e) => {
        const value = e.target.value;
        const docid = e.target.dataset.docid;

        db.collection("CustomEventFields")
        .doc(docid)
        .update({
            Title: value
        })
        .then(() => {
            setSaved('flex');
        });
    };

        // Function to translate indicator type
    const fieldType = (type) => {

        switch(type) {
            case 'scale':
                return 'Schaalvraag';
            case 'multiple-one':
                return 'Meerkeuze vraag met één mogelijk antwoord';
            case 'multiple-multiple':
                return 'Meerkeuze vraag met meerdere mogelijke antwoorden';
            case 'paragraph':
                return 'Open vraag';
            case 'number':
                return 'Numerieke vraag';
            default:
                return type;
        }
    }

    const columns = [
        { key: 'drag', label: '', searchable: false },
        { key: 'field', label: 'VELD' },
        { key: 'edit', label: 'AANPASSEN', searchable: false },
        { key: 'delete', label: 'VERWIJDEREN', searchable: false },
    ];

  return (
    <>
    {selectedOption === '4' &&
        <div className="settings-container">
            <div className="dashboard-container">
                <h2>Custom velden</h2>
                <Table
                        columns={columns}
                        items={dragArray || []}
                        getItemKey={(field) => field.ID}
                        renderRow={(field, index) => (
                            <>
                                <TableDragHandleCell>
                                    <DragIconTableData customEvent={{ ID: field.ID, Standard: field.Standard }} renderInCell={false} />
                                </TableDragHandleCell>
                                <TableCell>
                                    <input type="text" value={field.Title} data-docid={field.docid} onChange={customEventFieldTitleHandler} />
                                </TableCell>
                                <TableCell>
                                    <Tooltip content={'Indicator aanpassen'} width='80%' top='-60px'>
                                        <div id='edit-indicator-button-type-container'>
                                            <EditOutlinedIcon onClick={() => {
                                                setEditField(field.ID);
                                                setSelectedField(field);
                                                setSelectedFieldIndex(index);
                                                setModalOpen(true)
                                            }}/>
                                            <p>({fieldType(field.Type)})</p>
                                        </div>
                                    </Tooltip>
                                </TableCell>
                                <TableCell>
                                    <DeleteOutlinedIcon className='table-delete-icon' data-docid={field.docid} onClick={deleteCustomFieldHandler} />
                                </TableCell>
                            </>
                        )}
                        searchAccessor={(field) => field?.Title || ''}
                        searchPlaceholder="Zoeken op veld"
                        emptyMessage="Nog geen custom velden toegevoegd."
                        draggable
                        droppableId="customEventFields"
                        onDragEnd={handleDragEnd}
                        addRow={{
                            toolTipContent: 'Output toevoegen',
                            onClick: addCustomEventField,
                        }}
                    />
            </div>
            <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            pageHeader="Veld aanpassen"
            confirm={() => setModalOpen(false)}
            content={selectedField ? (
                <div>
                    {/* De titel stond vroeger IN de kop van de modal. De gedeelde
                        kop is een <h2> met een sluitknop, dus het invoerveld staat
                        nu in de inhoud — met een eigen label erboven. */}
                    <div className="edit-field-container">
                        <div id='event-builder-edit-field-title-container'>
                            <p><b>Titel</b></p>
                            <input
                            type="text"
                            defaultValue={selectedField.Title || ''}
                            data-docid={selectedField.docid}
                            onChange={customEventFieldTitleHandler}
                            />
                        </div>

                        <div id='event-builder-edit-field-select-container'>
                        <p><b>Type</b></p>
                        <select
                            value={selectedField.Type || ''}
                            data-docid={selectedField.docid}
                            onChange={(e) => {
                            const value = e.target.value;
                            const fieldDocId = e.target.dataset.docid;
                            db.collection('CustomEventFields').doc(fieldDocId).update({ Type: value });
                            // keep local state in sync so the select & FieldTypeConfig rerender
                            setSelectedField(prev => ({ ...prev, Type: value }));
                            }}
                        >
                            <option value="">-- Selecteer een type --</option>
                            <option value="date">Datum</option>
                            <option value="open">Open vraag</option>
                            <option value="scale">Schaal vraag</option>
                            <option value="number">Numerieke vraag</option>
                            <option value="multiple-one">Meerkeuze vraag (één keuze)</option>
                            <option value="multiple-multiple">Meerkeuze vraag (meerdere keuzes)</option>
                        </select>
                        </div>

                        <div>
                        <ActivityFieldTypeConfig
                            field={{ ...selectedField }}
                            fieldCollection="CustomEventFields"
                        />
                        </div>
                    </div>
                </div>
            ) : null}
            />
        </div>
        }
    </>
  )
}

export default Activities
